'use strict';
import * as $j_app$002eapi$002e$002dIn$002dMaintenance$002dData$0024 from "./app.api.-In-Maintenance-Data$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$35() {
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$35 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$35 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$35.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$35.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$35;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$35() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$35 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$35 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$35.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$35.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$35.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$35.prototype.apply__O = (function() {
  return $j_app$002eapi$002e$002dIn$002dMaintenance$002dData$0024.$m_Lapp_api_InMaintenanceData$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$35 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$35, "app.api.GeneralPracticeAppUpdate$$anon$35", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$35: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$35 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$35 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$35.js.map
